module.exports = __webpack_public_path__ + "assets/img/00133.1ff1120b.png";